// extracted by mini-css-extract-plugin
export default {"modal":"SimpleLoading_modal__gi0CQ","modalContent":"SimpleLoading_modalContent__kJzB2"};